module.exports = __webpack_public_path__ + "static/media/mu_nei_yi.675a8de7.png";